var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 1L2 6.5L7 12","stroke":"currentColor","strokeWidth":"2"}));
}

Left.defaultProps = {"width":"8","height":"13","viewBox":"0 0 8 13","fill":"none"};

module.exports = Left;

Left.default = Left;
